import React, { useState } from 'react';
import { Outlet, Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const Icon = ({ path, className = 'w-5 h-5' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d={path} />
  </svg>
);

const AdminLayout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();
  const { logout } = useAuth();

  const handleLogout = () => {
    logout();
    navigate('/admin/login');
  };

  const navItems = [
    { path: '/admin/dashboard', label: 'Dashboard', icon: 'M3 12h7V3H3zm11 9h7v-7h-7zM3 21h7v-5H3zm11-10h7V3h-7z' },
    { path: '/admin/leads', label: 'Leads', icon: 'M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M9 7a4 4 0 1 0 0-8 4 4 0 0 0 0 8m9 14v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75' },
    { path: '/admin/calendar', label: 'Calendar', icon: 'M8 2v4M16 2v4M3 10h18M5 4h14a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2' },
    { path: '/admin/blog', label: 'Blog Posts', icon: 'M4 19.5A2.5 2.5 0 0 1 6.5 17H20M6 2h14v20H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2z' },
    { path: '/admin/newsletter', label: 'Newsletter', icon: 'M4 4h16v16H4zm0 3 8 6 8-6' },
    { path: '/admin/scripts', label: 'Sales Scripts', icon: 'M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8zm0 0v6h6M8 13h8M8 17h5' },
    { path: '/admin/email-templates', label: 'Email Templates', icon: 'M4 6h16v12H4zm0 1 8 5 8-5' }
  ];

  return (
    <div className="min-h-screen bg-black text-white">
      <nav className="fixed top-0 left-0 right-0 h-16 bg-orange-950/85 backdrop-blur-md border-b border-white/10 z-50">
        <div className="h-full px-4 flex items-center justify-between">
          <div className="flex items-center gap-4">
            <button
              onClick={() => setIsSidebarOpen(!isSidebarOpen)}
              className="p-2 hover:bg-white/10 rounded-lg transition"
              aria-label="Toggle sidebar"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
            <Link to="/admin/dashboard">
              <img
                src="/logo.png"
                alt="The Alpha Consult admin"
                className="h-10 w-10 object-cover"
              />
            </Link>
          </div>

          <div className="flex items-center gap-4">
            <Link
              to="/"
              target="_blank"
              className="text-sm text-orange-300 hover:text-amber-300 transition font-nunito"
            >
              View Site
            </Link>
            <button
              onClick={handleLogout}
              className="px-4 py-2 bg-red-500/20 border border-red-500/50 rounded-lg text-red-200 hover:bg-red-500/30 transition font-nunito text-sm"
            >
              Logout
            </button>
          </div>
        </div>
      </nav>

      <aside
        className={`fixed top-16 left-0 bottom-0 bg-orange-900/40 border-r border-white/10 transition-all duration-300 z-40 ${
          isSidebarOpen ? 'w-64' : 'w-0'
        } overflow-hidden`}
      >
        <nav className="p-4 space-y-2">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`flex items-center gap-3 px-4 py-3 rounded-lg transition font-nunito ${
                location.pathname === item.path
                  ? 'bg-amber-500/20 text-amber-300 border border-amber-500/30'
                  : 'text-orange-200 hover:bg-white/5'
              }`}
            >
              <Icon path={item.icon} />
              <span className="font-medium">{item.label}</span>
            </Link>
          ))}
        </nav>
      </aside>

      <main
        className={`pt-16 transition-all duration-300 ${
          isSidebarOpen ? 'ml-64' : 'ml-0'
        }`}
      >
        <div className="p-6">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default AdminLayout;
